import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@ami/react/core';
import UnitOfMeasureType from '../coupler-styles/unitOfMeasureTypes';

export class UnitOfMeasureDropdown extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    selectedId: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    isClearable: PropTypes.bool,
    className: PropTypes.string,
  };

  state = {
    unitsTypes: [],
  };

  async componentDidMount() {
    const unitsTypes = await UnitOfMeasureType.all();
    this.setState({ unitsTypes: unitsTypes });
  }

  render() {
    const { unitsTypes } = this.state;
    const { className, placeholder, selectedId, onChange, isClearable } =
      this.props;

    return (
      <Dropdown
        className={className}
        placeholder={placeholder || 'Select...'}
        items={unitsTypes}
        selectedId={selectedId}
        onChange={onChange}
        isClearable={isClearable}
      />
    );
  }
}
